import { footerLinks } from "@/mocks/categories";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="relative w-full bg-[#0A1F1C] py-16 md:py-20 px-4 md:px-6 overflow-hidden">
      {/* World map background texture */}
      <div className="absolute inset-0 opacity-[0.04]">
        <img
          src="https://readdy.ai/api/search-image?query=Subtle%20abstract%20geometric%20network%20pattern%20in%20very%20low%20contrast%20white%20lines%20on%20dark%20background%2C%20sophisticated%20global%20commerce%20theme%2C%20clean%20minimalist%20connections%2C%20elegant%20nodes%20and%20links%2C%20corporate%20design%2C%20dark%20mode%20aesthetic&width=1800&height=1200&seq=footer-map-v2&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
          loading="lazy"
        />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20 mb-16">
          {/* Left: Brand */}
          <div className="lg:w-1/3">
            <div className="flex items-center gap-2 mb-6">
              <span className="font-heading text-2xl text-background-50">CSSBuy</span>
              <span className="w-2 h-2 rounded-full bg-accent-400"></span>
              <span className="font-heading text-2xl text-background-50">Sheet</span>
            </div>
            <p className="text-background-50/60 text-sm leading-relaxed mb-6 max-w-xs">
              {t("footer.tagline")}
            </p>
            <p className="font-heading text-lg text-background-50/80 leading-relaxed">
              Melhor CSSBuy Spreadsheet
              <br />
              2026 em Português
            </p>
          </div>

          {/* Right: Link Columns */}
          <div className="lg:w-2/3 grid grid-cols-2 sm:grid-cols-4 gap-8">
            {/* Artigos - Internal links */}
            <div>
              <h4 className="text-background-50 font-medium text-sm mb-4">{t("footer.articles")}</h4>
              <ul className="space-y-3">
                {footerLinks.artigos.map((link) => (
                  <li key={link.slug}>
                    <Link
                      to={`/artigo/${link.slug}`}
                      className="text-background-50/50 text-sm hover:text-background-50/80 transition-colors duration-200 whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Roupas */}
            <div>
              <h4 className="text-background-50 font-medium text-sm mb-4">{t("footer.clothing")}</h4>
              <ul className="space-y-3">
                {footerLinks.roupas.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-background-50/50 text-sm hover:text-background-50/80 transition-colors duration-200 whitespace-nowrap"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Calcados */}
            <div>
              <h4 className="text-background-50 font-medium text-sm mb-4">{t("footer.shoes")}</h4>
              <ul className="space-y-3">
                {footerLinks.calcados.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-background-50/50 text-sm hover:text-background-50/80 transition-colors duration-200 whitespace-nowrap"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Acessorios */}
            <div>
              <h4 className="text-background-50 font-medium text-sm mb-4">{t("footer.accessories")}</h4>
              <ul className="space-y-3">
                {footerLinks.acessorios.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-background-50/50 text-sm hover:text-background-50/80 transition-colors duration-200 whitespace-nowrap"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="flex flex-col sm:flex-row items-center justify-between pt-8 border-t border-background-50/10 gap-4">
          <p className="text-background-50/40 text-xs whitespace-nowrap">
            {t("footer.copyright")}
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="w-8 h-8 rounded-lg border border-background-50/20 flex items-center justify-center text-background-50/40 hover:text-background-50/70 hover:border-background-50/30 transition-colors duration-200 cursor-pointer">
              <i className="ri-twitter-x-line text-sm w-4 h-4 flex items-center justify-center"></i>
            </a>
            <a href="#" className="w-8 h-8 rounded-lg border border-background-50/20 flex items-center justify-center text-background-50/40 hover:text-background-50/70 hover:border-background-50/30 transition-colors duration-200 cursor-pointer">
              <i className="ri-instagram-line text-sm w-4 h-4 flex items-center justify-center"></i>
            </a>
            <a href="#" className="w-8 h-8 rounded-lg border border-background-50/20 flex items-center justify-center text-background-50/40 hover:text-background-50/70 hover:border-background-50/30 transition-colors duration-200 cursor-pointer">
              <i className="ri-reddit-line text-sm w-4 h-4 flex items-center justify-center"></i>
            </a>
            <a href="#" className="w-8 h-8 rounded-lg border border-background-50/20 flex items-center justify-center text-background-50/40 hover:text-background-50/70 hover:border-background-50/30 transition-colors duration-200 cursor-pointer">
              <i className="ri-discord-line text-sm w-4 h-4 flex items-center justify-center"></i>
            </a>
          </div>
          <span className="text-background-50/40 text-xs whitespace-nowrap">
            {t("footer.privacy")}
          </span>
        </div>
      </div>
    </footer>
  );
}